exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Groowtorials-module__wrapper___3wh7L{display:grid;gap:1.25rem;grid-template-columns:repeat(auto-fill,minmax(270px,1fr))}", ""]);

// exports
exports.locals = {
	"wrapper": "Groowtorials-module__wrapper___3wh7L"
};